import './TakeYourBusinessFurther.scss'

import React, { useEffect, useState } from 'react'

import { Carousel, CarouselSlide, Column, GridContainer, Row, useScreenClass } from '@vp/swan'

import { FeatureGroupModel, HeroModel } from '@vp/digital-common-data-model-lib-ubik'

import { PROMOTION_TRACKING_SPECS } from '../WixWebsitesAnalytics'
import MissingContentAlert from '../../../common/MissingContentAlert'
import PartnerCarouselSlide from './PartnerCarouselSlide'
import { BannerModel } from './PartnerCarouselSlide'

interface TakeYourBusinessFurtherProps {
  content: HeroModel
  locale: string
  vistaWixDomainsCtaClick: Function
  logoMakerCtaClick: Function
  vistaWixPlusCtaClick: Function
  yelpCtaClick: Function
  accessibility: FeatureGroupModel
}

const LOGO_MAKER_BANNER_ENABLED_LOCALES: string[] = [
  'en-us',
  'en-ie',
  'en-ca',
  'fr-ca',
  'en-au',
  'en-nz',
  'en-sg',
  'en-gb',
  'de-at',
  'de-ch',
  'de-de',
  'fr-ch',
  'fr-fr',
]

const VISTA_WIX_PLUS_BANNER_ENABLED_LOCALES: string[] = []

const YELP_BANNER_ENABLED_LOCALES: string[] = ['en-us', 'es-us', 'en-ca', 'fr-ca']

const TakeYourBusinessFurther = ({
  content,
  locale,
  vistaWixDomainsCtaClick,
  logoMakerCtaClick,
  vistaWixPlusCtaClick,
  yelpCtaClick,
  accessibility,
}: TakeYourBusinessFurtherProps) => {
  const [isMobile, setIsMobile] = useState(false)
  const [isSmall, setIsSmall] = useState(false)

  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  const screenSize = isClient ? useScreenClass() : undefined

  useEffect(() => {
    if (screenSize) {
      setIsMobile(screenSize === 'xs')
      setIsSmall(screenSize === 'sm')
    }
  }, [screenSize])

  if (!content) {
    return <MissingContentAlert />
  }

  const bannersRaw = [
    {
      feature: content?.heroMetadata?.[3],
      ctaClick: () => yelpCtaClick(),
      isEnabled: YELP_BANNER_ENABLED_LOCALES.includes(locale),
      trackingSpecsKey: PROMOTION_TRACKING_SPECS.yelp,
    },
    {
      feature: content?.heroMetadata?.[0],
      ctaClick: () => vistaWixDomainsCtaClick(),
      isEnabled: true,
      trackingSpecsKey: null,
    },
    {
      feature: content?.heroMetadata?.[1],
      ctaClick: () => logoMakerCtaClick(),
      isEnabled: LOGO_MAKER_BANNER_ENABLED_LOCALES.includes(locale),
      trackingSpecsKey: null,
    },
    {
      feature: content?.heroMetadata?.[2],
      ctaClick: () => vistaWixPlusCtaClick(),
      isEnabled: VISTA_WIX_PLUS_BANNER_ENABLED_LOCALES.includes(locale),
      trackingSpecsKey: null,
    },
  ]

  const banners: Array<BannerModel> = bannersRaw.filter((banner: any) => banner.isEnabled) || []

  return (
    <GridContainer>
      <Row>
        <Column span={12} px={0}>
          <Carousel
            initialSlide={0}
            mb={0}
            pb={{ xs: 5, sm: 5, md: 5 }}
            slidesToShow={1}
            slidesToScroll={1}
            progressIndicator="dots"
            arrows={!isMobile && !isSmall && banners?.length > 1}
            accessibleTextForDots={
              banners.length > 0 ? banners.map((banner, index) => accessibility.features[5]?.title.replace('{{SLIDE_NUMBER}}', String(index + 1)) ?? '') : []
            }
            accessibleTextForVisibleSlides={accessibility.features[2]?.hoverText}
            accessibleTextForSlide={accessibility.features[2]?.altText}
            accessibleTextForNext={accessibility.features[4].title}
            accessibleTextForPrevious={accessibility.features[3].title}
            aria-roledescription={accessibility.features[0].title}
            aria-label={content.title}
            className="wix-websites-pdp__take-your-business-further__carousel"
          >
            {banners.map((banner: BannerModel, index: number) => (
              <CarouselSlide aria-roledescription={accessibility.features[1].title} key={`cardSlide_${index + 1}`}>
                <PartnerCarouselSlide banner={banner} />
              </CarouselSlide>
            ))}
          </Carousel>
        </Column>
      </Row>
    </GridContainer>
  )
}

export default TakeYourBusinessFurther
